import { Package } from '../../../packages/package'
import { WorkOrderStorageLocationOverview } from '../../../orders/work-orders/work-order'
import { PackageCheckinMode } from '../../../storage/nodes/storage-node'

export class WorkOrderStorageLocationUtil {
  public static hasPackages(packages: Package[]): boolean {
    return packages?.length > 0
  }

  public static isEmpty(pkg: Package): boolean {
    return (pkg!.items?.length ?? 0) === 0
  }

  public static isAutoCheckInNecessary(overview: WorkOrderStorageLocationOverview): boolean {
    return this.isAutoCheckInEnabled(overview) && !this.hasCurrentPackageLocation(overview)
  }

  public static isManualCheckInNecessary(overview?: WorkOrderStorageLocationOverview): boolean {
    const manual = !this.isAutoCheckInEnabled(overview)
    const unassigned = !this.hasCurrentPackageLocation(overview)
    return manual && unassigned
  }

  public static hasCurrentPackageLocation(overview?: WorkOrderStorageLocationOverview): boolean {
    return overview?.currentPackageLocation != null
  }

  public static isAutoCheckInEnabled(overview?: WorkOrderStorageLocationOverview): boolean {
    return overview?.baseLocation?.packageCheckinMode === PackageCheckinMode.AUTO
  }
}
